
export default {
  header: {
    title: 'Pricing that scales with your business',
    description: 'Try Iterio free for 14 days',
  },
  plans: [{
    stars: 1,
    name: 'Startup',
    description: 'For growing e-commerce with up to 10k monthly visitors.',
    price: 150,
    period: 'month',
    priceHeading: 'Starting from',
    featuresDescription: 'All the power of Iterio to boost your sales in a few clicks.',
    features: [{
      icon: '',
      name: 'feature 1',
    }, {
      icon: '',
      name: 'feature 1',
    }],
  }, {
    stars: 2,
    name: 'Growth',
    description: 'For growing e-commerce with 50k to 100k monthly visitors.',
    price: 1500,
    period: 'month',
    priceHeading: 'Starting from',
    featuresDescription: 'Unlock advanced targeting features and dedicated support.',
    features: [{
      icon: '',
      name: 'feature 1',
      hover: 'Phasellus luctus fringilla lacus id lobortis. Morbi rutrum, orci sed dictum aliquam, dolor lacus ultricies dui, vel lacinia risus diam et leo. Sed semper neque arcu, quis dapibus nibh pellentesque eget. Nunc facilisis neque quis ultricies dictum.',
    }, {
      icon: '',
      name: 'feature 1',
    }, {
      icon: '',
      name: 'feature 1',
    }],
  }, {
    stars: 3,
    name: 'Business',
    description: 'For evolving e-commerce with +300k and up monthly visitors.',
    price: 3000,
    period: 'month',
    priceHeading: 'Starting from',
    featuresDescription: 'Improve performance with enterprise-level features and custom services.',
    hover: 'BEST VALUE',
    features: [{
      icon: '',
      name: 'feature 1',
    }, {
      icon: '',
      name: 'feature 1',
    }, {
      icon: '',
      name: 'feature 1',
    }, {
      icon: '',
      name: 'feature 1',
    }],
  }, {
    stars: 5,
    name: 'Enterprise',
    description: 'For evolving e-commerce with +300k and up monthly visitors.',
    price: 'CONTACT US',
    featuresDescription: 'Improve performance with enterprise-level features and custom services.',
    features: [{
      icon: '',
      name: 'feature 1',
    }, {
      icon: '',
      name: 'feature 1',
    }, {
      icon: '',
      name: 'feature 1',
    }, {
      icon: '',
      name: 'feature 1',
    }, {
      icon: '',
      name: 'feature 1',
    }],
  }],
};



// WEBPACK FOOTER //
// ./src/config/pricing.js